import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import './libs/jqBootstrapValidation';
import './libs/scrollreveal/scrollreveal';

$(function () {
    function trackEvent(type) {
        if (ga) {
            switch (type) {
                case 'register-success':
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Anmeldung',
                        eventAction: 'register',
                        eventLabel: 'Success'
                    });
                    break;

                case 'register-error':
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Anmeldung',
                        eventAction: 'register',
                        eventLabel: 'Error'
                    });
                    break;
            }
        }
    }

    $('input,select,textarea').not('[type=submit]').jqBootstrapValidation({
        //preventSubmit: true,
        //autoAdd: {
        //    helpBlocks: true
        //},
        sniffHtml: true,

        submitError: function ($form, event, errors) {
            // additional error messages or events
            console.warn('submitError', $form, event, errors);
        },
        submitSuccess: function ($form, event) {
            console.log('submitSuccess', $form, event);
            event.preventDefault(); // prevent default submit behaviour

            $("#register-button").prop("disabled", true); // Disable submit button until AJAX call is complete to prevent duplicate messages

            $.ajax({
                url: "./api/register.php",
                type: "POST",
                data: $('form').serialize(),
                cache: false,
                success: function (a, b, c) {
                    console.info('sucessful submit of form', a, b, c);
                    // Success message
                    $('#success').html("<div class='alert alert-success'>");
                    $('#success > .alert-success').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
                        .append("</button>");
                    $('#success > .alert-success')
                        .append("<strong>Daten wurden gespeichert. </strong>");
                    $('#success > .alert-success')
                        .append('</div>');

                    $("form input, form textarea").attr('disabled', 'disabled')

                    //clear all fields
                    $('form').trigger("reset");

                    trackEvent('register-success');



                },
                error: function () {

                    // Fail message
                    $('#success').html("<div class='alert alert-danger'>");
                    $('#success > .alert-danger').html("<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>&times;")
                        .append("</button>");
                    $('#success > .alert-danger').append($("<strong>").text("Entschuldigung, es scheint ein Problem aufgetreten zu sein. Sie können uns auch die Daten per E-Mail zuschicken!"));
                    $('#success > .alert-danger').append('</div>');
                    //clear all fields
                    $('#contactForm').trigger("reset");


                    setTimeout(function () {
                        $("#register-button").$this.prop("disabled", false); // Re-enable submit button when AJAX call is complete
                    }, 1000);

                    trackEvent('register-error');
                },
                complete: function () {

                }
            });
        },
        filter: function () {
            return $(this).is(":visible");
        },
    });

    $("a[data-toggle=\"tab\"]").click(function (e) {
        e.preventDefault();
        $(this).tab("show");
    });
});
